import { Component, EventEmitter, Inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SortbyPipe } from '@netfoundry-ui/ui/pipes';
import {
    HostService,
    NETWORK_SERVICE,
    NetworkServiceV2,
    ProviderService,
    RegionService,
    NetworkControllerService,
    AllocatedIpService,
} from '@netfoundry-ui/shared/apiv2';
import { AgentService, ApiService } from '@netfoundry-ui/shared/services';
import { Agent, Environment, ENVIRONMENT } from '@netfoundry-ui/shared/model';
import { GrowlerData, GrowlerService } from '@netfoundry-ui/shared/growler';
import { ActivatedRoute, Router } from '@angular/router';
import _, { cloneDeep, unset, isEmpty } from 'lodash';
import { HttpErrorResponse } from '@angular/common/http';
import { BaseChartDirective } from 'ng2-charts';
import { ChartConfiguration, ChartType } from 'chart.js';
import moment from 'moment';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-agent-modal',
    templateUrl: './agent-modal.component.html',
    styleUrls: ['./agent-modal.component.scss'],
    standalone: false
})
export class AgentModalComponent implements OnInit {
    @ViewChild(BaseChartDirective) chart?: BaseChartDirective;

    model: Agent;
    orgId;
    @Input() formData: any = {};
    frontdoorId;
    networkControllerId;
    networkId;
    isEditing = false;
    formView = 'simple';
    @Input() entityId: string;
    @Output() dataChange: EventEmitter<any> = new EventEmitter<any>();
    _dataChange = false;
    token;
    provider = 'AWS';
    close: EventEmitter<any> = new EventEmitter<any>();
    basePath = '';
    isV2
    baseHref: any;
    private subscription = new Subscription();
    previousRoute;
    description;
    get firstCommand(): string {
        return this.isV2
            ? 'curl -s https://get.netfoundry.io/linux-install.bash | sudo bash -s -- --test frontdoor-agent'
            : 'curl -s https://get.netfoundry.io/linux-install.bash | sudo bash -s frontdoor-agent';
    }
    get secondCommand(): string {
        const base = 'sudo -u frontdoor-agent frontdoor-agent enroll ';
        if (!this.environment.production) {
            return base + `--enrollment-gateway ${this.environment.protocol}://${this.environment.gatewayUrl} `;
        }
        return base;
    }
    thirdCommand = 'sudo systemctl enable --now frontdoor-agent.service';

    get combinedScript(): string {
        const enrollCmd = this.description
            ? `${this.secondCommand}${this.token} --description "${this.description}"`
            : `${this.secondCommand}${this.token}`;
        return `${this.firstCommand}\n${enrollCmd}\n${this.thirdCommand}`;
    }
    debugCommand = '';
        hostData: any;

    constructor(
        private agentService: AgentService,
        private apiService: ApiService,
        public growlerService: GrowlerService,
        private router: Router,
        private route: ActivatedRoute,
        @Inject(ENVIRONMENT) private environment: Environment,
    ) {
    this.previousRoute = router?.getCurrentNavigation()?.previousNavigation?.finalUrl?.toString();
        this.subscription.add(
            this.route?.params?.subscribe(params => {
                const zId = params['zId'];
                if (isEmpty(zId)) {
                    this.entityId = 'enroll';
                } else {
                  this.entityId = zId;
                }
            })
        );
        this.subscription.add(
            router?.events.subscribe((event: any) => {
                  if (!event?.snapshot?.routeConfig?.path) {
                      return;
                  }
                  const pathSegments = event.snapshot.routeConfig.path.split('/');
                  this.basePath = pathSegments[0];
                
            })
        );
        this.initBaseHref();
    }

    ngOnInit() {
        this.subscription.add(
            this.apiService.currentTenant.subscribe((tenant) => {
                this.orgId = tenant.id
                this.agentService.getAccountById(this.orgId).subscribe((frontdoor: any) => {
                    this.frontdoorId = frontdoor.id
                    if(frontdoor.version === 1) {
                        this.isV2 = false;
                    } else {
                        this.isV2 = true;
                    }
                    this.agentService.getEnrollmentToken(this.frontdoorId, this.orgId, this.isV2).subscribe((data: any) => {
                        this.token = data.bootstrapToken
                    })
                })
            })
        );
    }

    copyText(text: string) {
        navigator.clipboard.writeText(text).then(() => {
            this.growlerService.show(
                new GrowlerData(
                    'success',
                    'Success',
                    'Copied to clipboard',
                     'Command has been copied to your clipboard'
                )
            );
        });
    }
        copyToken(text: string) {
        navigator.clipboard.writeText(text).then(() => {
            this.growlerService.show(
                new GrowlerData(
                    'success',
                    'Success',
                    'Copied to clipboard',
                     'Token has been copied to your clipboard'
                )
            );
        });
    }

              headerActionRequested(action: any) {
            switch(action.name) {
                case 'close':
                    this.closeForm();
                    break;
                case 'toggle-view':
                    this.formView = action.data;
                    break;
                }
            }


        closeForm(refresh = true, ignoreChanges = false, data?, event?) {
      if (!ignoreChanges && this._dataChange) {
          const confirmed = confirm('You have unsaved changes. Do you want to leave this page and discard your changes or stay on this page?');
          if (!confirmed) {
              return;
          }
      }
          this.returnToListPage();
    }
          
    initBaseHref() {
        try {
            const base = document?.querySelector('base');
            this.baseHref = base ? base.getAttribute('href') : '/';
        } catch (error) {
            this.baseHref = '/';
        }
    }

returnToListPage() {
      this.router?.navigateByUrl(`${this.basePath}/agents`);

  }

      
    closeModal(refresh = true, ignoreChanges = false, data?: any, event?: any): void {
        this.close.emit({refresh: refresh});
        if (event) {
            event.stopPropagation();
        }
    }
}
